module.exports = __webpack_public_path__ + "static/firefox-eeaf8c7d830dabc70a3536c2270f2cc7.png";